import React, { useEffect, useRef } from "react";

const Whychhoseusus = () => {
  const titleRef = useRef(null);
  const paraRef = useRef(null);
  const paraRef1 = useRef(null);
  const datadetailRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            // Remove class when element goes out of view so it re-triggers on scroll again
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const elements = [
      titleRef.current,
      paraRef.current,
      paraRef1.current,
      datadetailRef.current,
      imgRef.current,
    ];
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return (
    <div className="container-fluid whychooseSection black_fullwidth pb-5">
      <div className="container">
        <div className="row">
          <div
            ref={titleRef}
            className="title_line text-center p-5 animate-title"
          >
            Why choose us
          </div>
          <div className="col-md-5 whychoose">
            <p ref={paraRef} className="mt-2 animate-para">
              In the era of rapid change, where AI evolves overnight, security
              threats multiply, and every dollar invested must fuel measurable
              ROI, we have got your back. We bring proven expertise, building
              clear roadmaps, and turning emerging technology into reliable
              results. <br />
              <br /> Thinking of smarter automation, integrated systems,
              fortified security, or AI adoption that delivers? Count on us so
              you can get ahead of the unexpected and drive forward with
              confidence.
            </p>
          </div>
          <div className="col-md-7 animate-para" ref={paraRef1}>
            <div class="row">
              <div className="col-md-6 mb-1 p-2">
                <div className="choosePoint">
                  <div></div>
                  <div className="title_lineNew">
                    <span class="material-icons material-symbols-outlined chooose_wrapperico">
                      emoji_objects
                    </span>
                    <span className="chooose_wrapperContent">
                      Results you can measure
                    </span>
                  </div>
                  <div className="tagdescription">
                    we build every solution to show real impact, not just
                    reports.
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-1 p-2">
                <div className="choosePoint">
                  <div className="title_lineNew">
                    <span class="material-icons material-symbols-outlined chooose_wrapperico">
                      api
                    </span>
                    <span className="chooose_wrapperContent">
                      Flexibility that fits you
                    </span>
                  </div>
                  <div>we’re here during development and after launch</div>
                </div>
              </div>

              <div className="col-md-6 p-2">
                <div className="choosePoint">
                  <div className="title_lineNew">
                    <span class="material-icons material-symbols-outlined chooose_wrapperico">
                      currency_rupee
                    </span>
                    <span className="chooose_wrapperContent">
                      Transparent billing
                    </span>
                  </div>
                  <div>
                    pay for what you use, without being locked into long
                    contracts.
                  </div>
                </div>
              </div>

              <div className="col-md-6 p-2">
                <div className="choosePoint">
                  <div className="title_lineNew chooose_wrapper">
                    <span class="material-icons material-symbols-outlined chooose_wrapperico">
                      star_shine
                    </span>
                    <span className="chooose_wrapperContent">
                      No sugarcoating, no surprises
                    </span>
                  </div>
                  <div>
                    We commit only to what we can deliver and always follow
                    through
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whychhoseusus;
